'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

var _diablo = require('../../mixins/diablo');

var _diablo2 = _interopRequireDefault(_diablo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var dom = weex.requireModule('dom');
var modal = weex.requireModule('modal');
exports.default = {
  mixins: [_colmo2.default, _diablo2.default],
  props: {
    list: {
      type: Array,
      required: true
    },
    flowConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    leftContent: {
      type: Boolean,
      default: false
    },
    leftContentStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    cItems: function cItems() {
      return this.adapter(this.list);
    }
  },
  data: function data() {
    return {
      rightContentWidth: null
    };
  },

  methods: {
    adapter: function adapter(items) {
      var _this = this;

      var _flowConfig = this.flowConfig,
          lineColor = _flowConfig.lineColor,
          pointInnerColor = _flowConfig.pointInnerColor,
          highlightTitleColor = _flowConfig.highlightTitleColor,
          highlightPointInnerColor = _flowConfig.highlightPointInnerColor,
          titleSize = _flowConfig.titleSize,
          highlightPointOuterColor = _flowConfig.highlightPointOuterColor;

      var len = items.length;
      var pre = Date.now();

      return items.map(function (item, index) {
        item.key = pre + '_' + index;
        item.__titleLineClass__ = [];
        item.__contentClass__ = [];
        item.__contentLineClass__ = [];
        item.__pointClass__ = [];
        item.__titleTextClass__ = [];
        item.__pointStyle__ = {};
        item.__lineStyle__ = {};
        item.__titleStyle__ = {};

        if (lineColor) item.__lineStyle__.backgroundColor = lineColor;
        if (pointInnerColor) item.__pointStyle__.backgroundColor = pointInnerColor;
        if (titleSize) item.__titleStyle__.fontSize = titleSize; //add by lau 新增设置标题字体大小
        if (_this.rightContentWidth) {
          item.__titleStyle__.width = _this.rightContentWidth + 'px';
        }
        // if (pointBorderColor) item.__pointStyle__.borderColor = pointBorderColor;

        if (index === 0) {
          item.__titleLineClass__.push('first-one-title-line');
        }

        if (index === len - 1) {
          item.__titleLineClass__.push('last-one-title-line');
          item.__contentClass__.push('last-one-content');
          item.__contentLineClass__.push('last-one-content-line');
        }

        if (item.highlight) {
          item.__pointClass__.push('highlight-point');
          item.__titleTextClass__.push('text-highlight-title');
          if (highlightTitleColor) item.__titleStyle__.color = highlightTitleColor;
          if (highlightPointOuterColor) {
            item.__pointStyle__.backgroundColor = highlightPointOuterColor;
          } else if (!highlightPointOuterColor && highlightPointInnerColor) {
            item.__pointStyle__.backgroundColor = highlightPointInnerColor;
          } else if (!_this._isColmo) {
            item.__pointStyle__.backgroundColor = _this._isDiablo ? '#0e2c3b' : 'rgba(2,162,242,0.2)';
          }
          if (highlightPointInnerColor) item.__pointStyle__.innerBackgroundColor = highlightPointInnerColor;

          // if (highlightPointBorderColor) item.__pointStyle__.borderColor = highlightPointBorderColor;
        }
        return item;
      });
    },


    // add by lau
    colorToRGBA: function colorToRGBA(color) {
      var color1, color2, color3;
      color = '' + color;
      if (typeof color !== 'string') return;
      if (color.charAt(0) == '#') {
        color = color.substring(1);
      }
      if (color.length == 3) {
        color = color[0] + color[0] + color[1] + color[1] + color[2] + color[2];
      }
      if (/^[0-9a-fA-F]{6}$/.test(color)) {
        color1 = parseInt(color.substr(0, 2), 16);
        color2 = parseInt(color.substr(2, 2), 16);
        color3 = parseInt(color.substr(4, 2), 16);
        var rgbaColor = 'rgba(' + color1 + ',' + color2 + ',' + color3 + ',' + 0.1 + ')';
        console.log('rgbaColor edn', rgbaColor);
        return rgbaColor;
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    setTimeout(function () {
      dom.getComponentRect(_this2.$refs.rightContent[0], function (rect) {
        if (rect && rect.size) {
          _this2.rightContentWidth = rect.size.width - 140;
        }
      });
    }, 20);
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-simple-flow/index.vue
// module id = 391
// module chunks = 0 1